import React from 'react';
import { oohData } from '../utils/oohData';
import { CheckIcon, ArrowRightIcon, EyeIcon, FlaskConicalIcon } from 'lucide-react';
export const AttentionTestingCTA: React.FC = () => {
  const {
    attentionTesting,
    methodology
  } = oohData;
  return <div className="space-y-4" data-id="element-18">
      {/* Observation framing — sets up why testing is the next step */}
      <div className="bg-white rounded-xl shadow-sm p-5 flex items-start space-x-3" data-id="element-19">
        <div className="p-2 bg-gray-100 text-gray-500 rounded-lg flex-shrink-0" data-id="element-20">
          <EyeIcon className="w-5 h-5" data-id="element-21" />
        </div>
        <p className="text-sm text-gray-600 leading-relaxed" data-id="element-22">
          {methodology.observationNote}
        </p>
      </div>

      {/* The upsell / link to Attention Testing */}
      <div className="bg-[#1E90FF] rounded-xl shadow-sm p-8 text-white" data-id="element-23">
        <div className="flex flex-col lg:flex-row lg:items-center gap-8" data-id="element-24">
          <div className="flex-1" data-id="element-25">
            <div className="flex items-center space-x-2 mb-3" data-id="element-26">
              <FlaskConicalIcon className="export-icon-down w-5 h-5 text-white/90" data-id="element-27" />
              <span className="text-xs font-semibold uppercase tracking-wider text-white/90" data-id="element-28">
                {attentionTesting.eyebrow}
              </span>
            </div>
            <h3 className="text-xl md:text-2xl font-semibold leading-tight mb-3" data-id="element-29">
              {attentionTesting.heading}
            </h3>
            <p className="text-sm text-white/85 leading-relaxed mb-5 max-w-2xl" data-id="element-30">
              {attentionTesting.body}
            </p>
            <ul className="space-y-2" data-id="element-31">
              {attentionTesting.bullets.map((bullet, idx) => <li key={idx} className="flex items-start space-x-2.5" data-id="element-32">
                  <span className="mt-0.5 flex-shrink-0 flex items-center justify-center w-4 h-4 rounded-full bg-white/20" data-id="element-33">
                    <CheckIcon className="w-3 h-3" data-id="element-34" />
                  </span>
                  <span className="text-sm text-white/90 leading-relaxed" data-id="element-35">
                    {bullet}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="lg:flex-shrink-0" data-id="element-36">
            <a href={attentionTesting.ctaHref} target="_blank" rel="noopener noreferrer" data-export-hide className="inline-flex items-center justify-center space-x-2 bg-white text-[#1E90FF] px-6 py-3 rounded-lg font-semibold hover:bg-white/90 transition-colors whitespace-nowrap" data-id="element-37">
              <span data-id="element-38">{attentionTesting.ctaLabel}</span>
              <ArrowRightIcon className="w-4 h-4" data-id="element-39" />
            </a>
          </div>
        </div>
      </div>
    </div>;
};